module.exports = __webpack_public_path__ + "img/OL.d9a79bd1.png";